import { type TabOwnerState } from '@mui/base'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { Chip, type ChipProps } from 'base-ui'

type StoryblokTabChipProps = ChipProps & {
  ownerState: TabOwnerState
}

export const StoryblokTabChip: FC<StoryblokTabChipProps> = ({
  className,
  ownerState,
  ...rest
}) => (
  <Chip
    className={clsx(className, 'tablet:chip_medium')}
    selected={ownerState.selected}
    size="small"
    {...rest}
  />
)
